module.exports = __webpack_public_path__ + "static/1-asset-3-d@2x-09e238727777a7de64ba2e79be5ccdaf.png";